import React from 'react';

interface IBackIcon {
  className?: string;
  onClick?: () => void;
  size?: string;
  color?: string;
}

const BackIcon: React.FC<IBackIcon> = props => {
  const { className = '', onClick, size = '12', color = 'var(--navi-color-gray-c2)' } = props;
  return (
    <svg
      className={className}
      onClick={onClick}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask id="mask0_243_25050" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
        <rect x="24" width="24" height="24" transform="rotate(90 24 0)" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_243_25050)">
        <path
          d="M21 12C21 12.5523 20.5523 13 20 13L6.825 13L11.7125 17.8875C12.105 18.28 12.1021 18.9172 11.7062 19.3062C11.3152 19.6904 10.6876 19.6876 10.3 19.3L3.70711 12.7071C3.31658 12.3166 3.31658 11.6834 3.70711 11.2929L10.3 4.70003C10.6876 4.31242 11.3152 4.30964 11.7062 4.69381C12.1021 5.08281 12.105 5.72003 11.7125 6.11253L6.825 11L20 11C20.5523 11 21 11.4477 21 12Z"
          fill={color}
        />
      </g>
    </svg>
  );
};

export default BackIcon;
